import ErrorIcon from 'shared/icons/error-icon.svg';
import SuccessIcon from 'shared/icons/success-icon.svg';
import SuccessIconM from 'shared/icons/success-icon-monarch.svg';

export const CURRENT_DESIGN_SWAPPING = 'currentDesignSwapping';
export const FETCHING_RENDER = 'fetchingRender';
export const CURRENT_DESIGN_COMPLETE = 'currentDesignComplete';
export const LONGER_SWAP = 'longerSwap';
export const OTHER_DESIGN_COMPLETE = 'otherDesignComplete';
export const CURRENT_DESIGN_FAILED = 'currentDesignFailed';
export const NETWORK_ERROR = 'networkError';
export const PRODUCT_NOT_SWAPPABLE = 'productNotSwappable';
export const ALREADY_SWAPPING_ON_DESIGN = 'alreadySwappingOnDesign';
export const CURRENT_DESIGN_CANCELLED = 'currentDesignCancelled';

export const SWAP_INFO_COPY = {
  [CURRENT_DESIGN_SWAPPING]: {
    leadText: 'Your Swap Is in Progress!',
    subText: null,
    actionText: null,
    shouldSetCloseTimeout: false,
    iconSrc: null
  },
  [FETCHING_RENDER]: {
    leadText: 'Hold on Tight!',
    actionText: null,
    subText: 'We are finishing up updates to your products in this angle too!',
    shouldSetCloseTimeout: false,
    iconSrc: null
  },
  [CURRENT_DESIGN_COMPLETE]: {
    leadText: 'Success!',
    subText: `You've swapped a product.`,
    actionText: null,
    shouldSetCloseTimeout: true,
    iconSrc: SuccessIcon,
    iconSrcM: SuccessIconM
  },
  [OTHER_DESIGN_COMPLETE]: {
    leadText: 'Success!',
    subText: `You've swapped a product.`,
    actionText: 'SEE IT',
    shouldSetCloseTimeout: true,
    iconSrc: SuccessIcon,
    iconSrcM: SuccessIconM
  },
  [CURRENT_DESIGN_FAILED]: {
    leadText: `Something went wrong!`,
    subText: 'Try to swap another product.',
    actionText: null,
    shouldSetCloseTimeout: false,
    iconSrc: ErrorIcon
  },
  [CURRENT_DESIGN_CANCELLED]: {
    leadText: `Your Swap Has Been Cancelled.`,
    subText: null,
    actionText: null,
    shouldSetCloseTimeout: false,
    iconSrc: ErrorIcon
  },
  [NETWORK_ERROR]: {
    leadText: `Hey, it looks like you're offline`,
    subText: 'try re-connecting and then try your swap again!',
    actionText: null,
    shouldSetCloseTimeout: false,
    iconSrc: ErrorIcon
  },
  [PRODUCT_NOT_SWAPPABLE]: {
    leadText: `We Can't Swap This Product Now`,
    subText: 'Try to swap another product!',
    actionText: null,
    shouldSetCloseTimeout: false,
    iconSrc: ErrorIcon
  },
  [LONGER_SWAP]: {
    leadText: `Hm, looks like this is taking a bit longer than expected`,
    subText: 'should just be another minute or so!',
    actionText: null,
    shouldSetCloseTimeout: false,
    iconSrc: ErrorIcon
  },
  [ALREADY_SWAPPING_ON_DESIGN]: {
    leadText: 'You currently have a swap in progress.',
    subText: 'Please wait until that swap is finished.',
    actionText: null,
    shouldSetCloseTimeout: false,
    iconSrc: ErrorIcon
  },

  modal: {
    [ALREADY_SWAPPING_ON_DESIGN]: {
      leadText: `There's already a product swap in progress!`,
      subText: `
        Once your most recent swap is complete, you'll be able to swap again.
      `,
      actionText: 'Close',
      shouldSetCloseTimeout: false,
      iconSrc: ErrorIcon
    }
  }
};
